// Module
var code = "<td name=productCategories>{{ record.key | entityFormat }}</td> <td name=quantity>{{ getRemainingQuantity(record) }}</td> <td name=shipmentUnitProductQuantity>{{ getRemainingProductQuantity(record) }}</td> ";
// Exports
module.exports = code;